import { ApiSubUrls, Apis } from 'enums/api-constants'
import { MetricDetail } from 'hooks/operations/useDimensions'
import { fetchGeneralData } from 'queries/fetchData'
import { TableData } from 'utils/data'

export const fetchDimensions = fetchGeneralData<MetricDetail[]>(
    `${ApiSubUrls[Apis.DIMENSIONS]}`,
)
export const fetchOperationsMetricsDetails = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)
